export default __webpack_public_path__ + "static/media/React-icon.3adc4d15.svg";